<script lang="ts" setup>
    defineProps<{
        countdown: number
        maxSeconds?: number
    }>()
</script>

<template>
    <div class="pk-retry-countdown">
        <div class="pk-retry-countdown__loader">
            <div class="pk-retry-countdown__bubble">
                <div class="pk-retry-countdown__typing">
                    <span class="pk-retry-countdown__dot"></span>
                    <span class="pk-retry-countdown__dot"></span>
                    <span class="pk-retry-countdown__dot"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .pk-retry-countdown {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: var(--spacing-sm);

        &__loader {
            position: relative;
            width: 80px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        &__bubble {
            background: var(--color-surface-2);
            border: 2px solid var(--color-surface-4);
            border-radius: 20px;
            padding: var(--spacing-md) var(--spacing-lg);
            position: relative;
            animation: pk-retry-countdown-pulse 2s ease-in-out infinite;

            &::after {
                content: '';
                position: absolute;
                bottom: -8px;
                left: 20px;
                width: 0;
                height: 0;
                border-left: 8px solid transparent;
                border-right: 8px solid transparent;
                border-top: 8px solid var(--color-surface-4);
            }

            &::before {
                content: '';
                position: absolute;
                bottom: -6px;
                left: 21px;
                width: 0;
                height: 0;
                border-left: 7px solid transparent;
                border-right: 7px solid transparent;
                border-top: 7px solid var(--color-surface-2);
                z-index: 1;
            }
        }

        &__typing {
            display: flex;
            gap: var(--spacing-xs);
            align-items: center;
        }

        &__dot {
            width: 8px;
            height: 8px;
            background: var(--color-word-3);
            border-radius: 50%;
            animation: pk-retry-countdown-bounce 1.4s ease-in-out infinite;

            &:nth-child(1) {
                animation-delay: 0s;
            }

            &:nth-child(2) {
                animation-delay: 0.2s;
            }

            &:nth-child(3) {
                animation-delay: 0.4s;
            }
        }
    }

    @keyframes pk-retry-countdown-bounce {
        0%,
        60%,
        100% {
            transform: translateY(0);
            opacity: 0.7;
        }

        30% {
            transform: translateY(-12px);
            opacity: 1;
        }
    }

    @keyframes pk-retry-countdown-pulse {
        0%,
        100% {
            transform: scale(1);
        }

        50% {
            transform: scale(1.05);
        }
    }
</style>
